import { INVOICES_TABLE } from '@locales/invoices';
import { type Invoice } from '@operations/domain/types';

type ExtraColumnsIds =
  'totalAmount' | 'score' | 'managementStateId' | 'selection';

const INVOICE_TABLE_FIELDS = {
  SELECTION: {
    id: 'selection',
    label: '',
    enableVisibility: false,
    size: 50,
  },
  MANAGEMENT_STATE_ID: {
    id: 'managementStateId',
    label: 'Estado de gestión',
    enableVisibility: false,
  },
  SCORE: {
    id: 'score',
    label: 'Score',
    enableVisibility: false,
  },
  CLIENT_COMPANY_NAME: {
    id: 'clientName',
    label: INVOICES_TABLE.HEADERS.CLIENT_COMPANY_NAME,
    enableVisibility: true,
  },
  CLIENT_RUT: {
    id: 'clientRut',
    label: INVOICES_TABLE.HEADERS.CLIENT_RUT,
    enableVisibility: true,
  },
  DEBTOR_COMPANY_NAME: {
    id: 'debtorName',
    label: INVOICES_TABLE.HEADERS.DEBTOR_COMPANY_NAME,
    enableVisibility: true,
  },
  DEBTOR_RUT: {
    id: 'debtorRut',
    label: INVOICES_TABLE.HEADERS.DEBTOR_RUT,
    enableVisibility: true,
  },
  DEBTOR_COMPANY_RANKING: {
    id: 'debtorCompanyRanking',
    label: INVOICES_TABLE.HEADERS.DEBTOR_COMPANY_RANKING,
    enableVisibility: true,
  },
  RECEPTION_DATE: {
    id: 'receptionDate',
    label: INVOICES_TABLE.HEADERS.RECEPTION_DATE,
    enableVisibility: true,
  },
  TOTAL_AMOUNT: {
    id: 'totalAmount',
    label: INVOICES_TABLE.HEADERS.TOTAL_AMOUNT,
    enableVisibility: true,
  },
  FOLIO: {
    id: 'folio',
    label: INVOICES_TABLE.HEADERS.FOLIO,
    enableVisibility: true,
  },
  DOCUMENT_TYPE: {
    id: 'documentType',
    label: INVOICES_TABLE.HEADERS.DOCUMENT_TYPE,
    enableVisibility: true,
  },
  ACKNOWLEDGMENT_DATE: {
    id: 'acknowledgmentDate',
    label: INVOICES_TABLE.HEADERS.ACKNOWLEDGMENT_DATE,
    enableVisibility: true,
  },
  CLAIM_DATE: {
    id: 'claimDate',
    label: INVOICES_TABLE.HEADERS.CLAIM_DATE,
    enableVisibility: true,
  },
  ASSIGNEE_COMPANY_NAME: {
    id: 'assigneeCompanyName',
    label: INVOICES_TABLE.HEADERS.ASSIGNEE_COMPANY_NAME,
    enableVisibility: true,
  },
  ASSIGNEE_RUT: {
    id: 'assigneeRut',
    label: INVOICES_TABLE.HEADERS.ASSIGNEE_RUT,
    enableVisibility: true,
  },
  ASSIGNMENT_DATE: {
    id: 'assignmentDate',
    label: INVOICES_TABLE.HEADERS.ASSIGNMENT_DATE,
    enableVisibility: true,
  },
  STATUS: {
    id: 'SIIState',
    label: INVOICES_TABLE.HEADERS.STATUS,
    enableVisibility: true,
  },
  AMOUNT: {
    id: 'amount',
    label: INVOICES_TABLE.HEADERS.AMOUNT,
    enableVisibility: true,
  },
  CREDIT_NOTE_AMOUNT: {
    id: 'creditNoteAmount',
    label: INVOICES_TABLE.HEADERS.CREDIT_NOTE_AMOUNT,
    enableVisibility: true,
  },
} satisfies Record<
  string,
  {
    id: keyof Invoice | ExtraColumnsIds;
    label: string;
    enableVisibility: boolean;
    size?: number;
  }
>;

export { INVOICE_TABLE_FIELDS };
